import { CardHeader } from "@mui/material";
import ActionMenu from "../../../../components/action-menu/ActionMenu";
import { ActionMenuItem } from "../../../../components/action-menu/ActionMenuItem";
import UserAvatar from "./UserAvatar";
import UserSubheader from "./UserSubheader";
import UserTitle from "./UserTitle";
import { UserAndRoleAdministrationUser } from "../../../../services/user-role-administration-service/Models";

export type UserCardHeaderProps = {
    user: UserAndRoleAdministrationUser;
    actionItems: ActionMenuItem[];
};

export default function UserCardHeader({
    user,
    actionItems
}: UserCardHeaderProps) {
    return (
        <CardHeader
            sx={{
                padding: 1
            }}
            title={<UserTitle user={user} />}
            avatar={<UserAvatar user={user} />}
            subheader={<UserSubheader user={user} />}
            action={
                <ActionMenu
                    actionItems={actionItems}
                    hideIfEmpty={true}
                />
            }
            slotProps={{
                action: {
                    sx: {
                        marginRight: actionItems.length > 0
                            ? undefined
                            : 1
                    }
                }
            }}
        />
    );
}
